import { IApplicationState } from '../../types/redux';

export function selectUsefulLinks(state: IApplicationState) {
  return state.usefulLinks;
}
